import React from "react";
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import hero4 from "assets/images/HomeBg1.webp";

function HeroSection() {
    return (
        <MKBox
            minHeight="75vh"
            width="100%"
            position="relative"
            sx={{
                backgroundColor: "#333333",
                backgroundSize: "cover",
                backgroundImage: `url(${hero4})`,
                backgroundPosition: "center",
                display: "grid",
                placeItems: "center",
                overflow: "hidden",
            }}
        >
            {/* Overlay */}
            <MKBox
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0, 0, 0, 0.4)",
                    zIndex: 1,
                }}
            />

            <Container sx={{ position: "relative", zIndex: 2 }}>
                <Grid container item xs={12} lg={12} justifyContent="center">
                    <MKTypography
                        variant="h1"
                        color="white"
                        sx={() => ({
                            textAlign: "center",
                            fontSize: {
                                xs: "2rem",
                                sm: "2.5rem",
                                md: "3.5rem",
                                lg: "4rem",
                            },
                        })}
                    >
                        Curățenie de întreținere
                    </MKTypography>
                    <MKTypography
                        variant="subtitle1"
                        color="white"
                        textAlign="center"
                        px={{ xs: 5, lg: 12 }}
                        mt={2}
                        mb={4}
                        sx={{
                            fontSize: {
                                xs: "1rem",
                                sm: "1.25rem",
                                md: "1.5rem",
                            },
                        }}
                    >
                        Curățenia de întreținere este un proces sistematic care menține standardul
                        de igienă necesar unui mediu sănătos și plăcut. Intervențiile zilnice,
                        periodice sau part-time sunt stabilite împreună cu beneficiarul și adaptate
                        programului, productivității și evenimentelor speciale ale locației.
                    </MKTypography>
                </Grid>
            </Container>
        </MKBox>
    );
}

export default HeroSection;
